<template>
  <el-dialog
    :visible="visible"
    :title="$MGUI.i18n.t('表格字段设置')"
    width="1000px"
    :close-on-click-modal="false"
    @close="handleClose"
    :append-to-body="true"
  >
    <div class="columns-config">
      <div class="show-columns">
        <div class="header">
          <span>{{ $MGUI.i18n.t('展示字段') }}({{ visibleColumns.length }})</span>
          <span class="reset-btn" :class="{ active: isDraggable }" @click="handleReset">
            {{ $MGUI.i18n.t('重置') }}
            <i class="iconfont mg-icon_shuaxinshuju" />
          </span>
        </div>
        <MgDraggable
          @change="handleDragChange"
          @handleHidden="handleHidden"
          :list="visibleColumns"
          ghost-class="ghost"
        />
      </div>
      <div class="show-columns">
        <div class="header">
          <span>{{ $MGUI.i18n.t('隐藏字段') }}({{ hiddenColumns.length }})</span>
        </div>
        <div class="hidden_content">
          <span class="drag-group-item" v-for="item in hiddenColumns" :key="item.prop">
            {{ item.label }}
            <i class="iconfont mg-icon_add" @click="handleAdd(item)"></i>
          </span>
        </div>
      </div>
    </div>
    <span slot="footer">
      <div class="column-count">
        {{ $MGUI.i18n.t('列字段总数') }}:{{ visibleColumns.length + hiddenColumns.length }}
      </div>
      <el-button :disabled="false" @click="handleCancel">{{ $MGUI.i18n.t('取消') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :disabled="disabled">{{ $MGUI.i18n.t('提交') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import MgDraggable from './mg-draggable.vue'
  export default {
    props: {
      visible: Boolean,
      // 列是否可配置
      configurable: Boolean,
      columns: {
        type: Array,
        default: () => [],
      },
    },
    components: { MgDraggable },
    data() {
      return {
        isDraggable: false,
        // 展示的列
        visibleColumns: [],
        // 排序的列
        sortColumns: [],
        // 隐藏的列
        hiddenColumns: [],
      }
    },
    watch: {
      columns: {
        handler(values) {
          this.visibleColumns = [].concat(values.filter((item) => !item.hidden || item.edit))
          this.hiddenColumns = [].concat(values.filter((item) => item.hidden && !item.edit))
        },
        immediate: true,
      },
    },
    computed: {
      disabled() {
        return this.visibleColumns.length === 0 || !this.isDraggable
      },
    },
    methods: {
      handleHidden(item) {
        this.hiddenColumns.push({ ...item, hidden: true })
        this.visibleColumns = this.visibleColumns.filter((temp) => temp.prop !== item.prop)
        this.handleDragChange(this.visibleColumns)
      },
      handleAdd(item) {
        this.visibleColumns.push({ ...item, hidden: false })
        this.hiddenColumns = this.hiddenColumns.filter((temp) => temp.prop !== item.prop)
        this.handleDragChange(this.visibleColumns)
      },
      handleDragChange(data) {
        this.isDraggable = true
        this.sortColumns = data
      },
      handleReset() {
        if (this.isDraggable) {
          this.visibleColumns = [].concat(this.columns.filter((item) => !item.hidden || item.edit))
          this.hiddenColumns = [].concat(this.columns.filter((item) => item.hidden && !item.edit))
          this.isDraggable = false
        }
      },
      handleClose() {
        this.$emit('update:visible', false)
      },
      handleCancel() {
        this.handleReset()
        this.handleClose()
      },
      handleSubmit() {
        this.isDraggable = false
        this.$emit('column-change', [...this.sortColumns, ...this.hiddenColumns])
        this.handleClose()
      },
    },
  }
</script>

<style lang="scss" scoped>
  :deep(.el-dialog__body) {
    padding: 10px 20px;
  }
  .columns-config {
    display: flex;
    flex-direction: column;
    .show-columns {
      flex: 1;
      margin-right: 5px;
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 10px;
        .reset-btn {
          display: flex;
          align-items: center;
          color: #999;
          cursor: no-drop;
          &.active {
            cursor: pointer;
            color: #e60012;
            i {
              color: #e60012;
            }
          }
          i {
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
      .hidden_content {
        position: relative;
        padding: 10px 0 10px 10px;
        .drag-group-item {
          position: relative;
          padding: 5px 10px;
          cursor: pointer;
          margin-right: 10px;
          margin-bottom: 10px;
          display: inline-block;
          background: rgba(37, 42, 61, 0.05);
          &.fixed {
            opacity: 0.6;
            cursor: pointer;
            pointer-events: none;
            i {
              color: #999;
            }
          }
          &:hover {
            .mg-icon_add {
              display: inline;
            }
          }
          .mg-icon_add {
            display: none;
            position: absolute;
            top: -5px;
            z-index: 100;
            cursor: pointer;
            color: #45b60d;
            font-size: 18px;
          }
        }
      }
    }
  }
  .column-count {
    font-size: 12px;
    color: rgba(37, 42, 61, 0.8);
    line-height: 32px;
    float: left;
  }
</style>
<style>
  .ghost {
    background: rgba(230, 0, 18, 0.15) !important;
  }
</style>
